import { render, staticRenderFns } from "./MobilePage.vue?vue&type=template&id=c45649b6&scoped=true&"
import script from "./MobilePage.vue?vue&type=script&lang=js&"
export * from "./MobilePage.vue?vue&type=script&lang=js&"
import style0 from "./MobilePage.vue?vue&type=style&index=0&id=c45649b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45649b6",
  null
  
)

export default component.exports